<template>
	<dashboard :filters="filters" widget></dashboard>
</template>
<script>
	import { ref, computed, onMounted, inject } from "vue";
	import { useRoute } from "vue-router";
	import { dashboard } from "@/components/webComponents/widget";

	export default {
		components: {
			dashboard
		},
		props: {
			json: {
				type: String,
				default: undefined
			},
			pageFilters: {
				type: String,
				default: "{}"
			}
		},
		setup(props, context) {
			const $json = inject("$json");
			const moment = inject("$moment");

			const globalFilters = ref({});
			const filter = ref([]);

			if ($json.packed(props.pageFilters)) {
				globalFilters.value = JSON.parse($json.unpack(props.pageFilters));
			} else {
				globalFilters.value = JSON.parse(props.pageFilters || "{}");
			}

			if ($json.packed(props.json)) {
				filter.value = JSON.parse($json.unpack(props.json));
			} else {
				filter.value = JSON.parse(props.json || "[]");
			}

			const computeFilters = computed(() => {
				if (filter.value.length > 0) {
					return filter.value;
				} else if (globalFilters.value.AssignmentsFilter.length > 0) {
					return globalFilters.value.AssignmentsFilter;
				} else {
					return globalFilters.value.Parent?.AssignmentsFilter || [];
				}
			});

			const filters = computed(() => {
				const dateType = "activity";
				const dates = {
					startDate: moment.utc(new Date()).add(-1, "year").startOf("day").toDate(),
					endDate: moment.utc(new Date()).toDate(),
					selection: "1Y"
				};
				return {
					type: dateType,
					date: dates,
					keys: computeFilters.value
				};
			});

			return { filters };
		}
	};
</script>
